module.exports = __webpack_public_path__ + "img/image.f3c681d2.svg";